import {renderEventTimeBlock} from '@modules/liveControl/components/LiveControlTable/renderTime';
import {
    ARGOS_JOB_STATUS_RUNNING,
    ARGOS_JOB_STATUS_TERMINATED,
    ARGOS_STREAM_STATUS_CANCELLED,
    ARGOS_STREAM_STATUS_PROCESSING,
    ARGOS_STREAM_STATUS_PROCESSED,
} from '@constants/variables';

export const buildArgosRowForEventTimeHover = (row) => ({
    ...row,
    event_content_start_datetime: row.event_start_datetime,
    event_content_end_datetime: row.event_end_datetime,
    event_content_is_247_stream: false,
    property_licence_tech_setup_is_tv_streaming: false,
    match_tv_streaming_encoder_id: null,
    match_rts_coverage_id: null,
    match_has_live_scout: true,
    home_team_is_excluded: false,
    away_team_is_excluded: false,
    match_has_live_odds: true,
    match_has_underage_competitors: false,
    event_status: row.event_status_name,
});

export const renderArgosEventTimeCell = (row) => {
    if (!row.event_start_datetime) {
        return '-';
    }

    return renderEventTimeBlock(buildArgosRowForEventTimeHover(row), {
        rangeBetweenStartAndEnd: 'inlineDash',
        keyPrefix: 'ajlc_et',
        fragmentKeyPrefix: 'ajlc_et_frag',
    });
};

export const getRowClassname = (row) => {
    if (!row.job_uuid) {
        return '';
    }

    const jobStatus = String(row.job_status ?? '').toLowerCase();
    const streamStatus = String(row.stream_status ?? '').toLowerCase();

    if (ARGOS_JOB_STATUS_RUNNING === jobStatus && ARGOS_STREAM_STATUS_PROCESSING === streamStatus) {
        return '--green';
    }

    if (ARGOS_JOB_STATUS_TERMINATED === jobStatus
        && (ARGOS_STREAM_STATUS_PROCESSED === streamStatus || ARGOS_STREAM_STATUS_CANCELLED === streamStatus)) {
        return '';
    }

    return '--yellow';
};
